import { css } from "@linaria/core";
import { combineTokens } from "../css/util.combine-tokens";
import { units } from "../css-tokens/units";

export const tokens = combineTokens("--show-for", {
  from: units.px(0),
  to: units.px(100000),
});

// We need to be able to show/hide the container / its children based on dynamic
// media queries.
// As media queries does not support css-variables we instead 'hack' this using
// variables as logic gates as follows:
//
//  1) If the current viewport is greater than the from-value we set
//  --matches-from to 1px, otherwise it will be 0px.
//
//  2) If the current viewport is greater than the to-value we set
//  --not-matches-to to 1px, otherwise it will be 0px.
//
//  3) now, we flip --not-matches-to such that --matches-to will be 1px if the
//  viewport is smaller than the top of the breakpoint.
//
//  4) now, we combine these to determine if the current viewport matches the
//  breakpoint by ensuring that both --matches-from and --matches-to must be 1px
//  in order for our --matches value to become very large, effectively showing
// its content
export const ssrContainer = css`
  --matches-from: clamp(
    ${units.px(0)},
    100vw - ${tokens.from()},
    ${units.px(1)}
  );
  --not-matches-to: clamp(
    ${units.px(0)},
    100vw - ${tokens.to()},
    ${units.px(1)}
  );
  --matches-to: calc(${units.px(1)} - var(--not-matches-to));
  --matches: max(
    ${units.px(0)},
    calc((var(--matches-from) + var(--matches-to)) * 20000 - ${units.px(20000)})
  );

  position: relative;

  max-height: var(--matches);
  max-width: var(--matches);

  overflow: hidden;

  display: block !important;

  transform: translateZ(0);
`;
